











































































import CFMDialog from '@/scripts/CFMDialog'
import {Component} from 'vue-property-decorator';

import * as blockui from '@/helpers/block-ui'

import {required} from "vuelidate/lib/validators";

import { CFMDTOBrand } from '@/scripts/services/ClientApiAuto'
import BootstrapSwitchComponent from '@/components/shared/BootstrapSwitchComponent';

@Component<BrandDialog>({

  components:
  {
    'bootstrap-switch-component':BootstrapSwitchComponent
  },

  validations() {
      return {
      brand:{
          Name: {required},
          IsForTool:false,
          IsForCapacityEquipment:false,
          IsForSparePart:false,
          IsForDevice:false,
      }
      }
  },
})
export default class BrandDialog extends CFMDialog {
    brand: CFMDTOBrand = {Name: ''};

    async created(){
      console.log()
      blockui.blockModal(this);
      if(this.isUpdate){
        const res = await this.apiClient.brand.brandGetById({id: <number>this.id});
        this.brand = res.data;
      }
      if(this.isUpdate){
      
      }
      blockui.unBlockModal();
    }

    async onSubmit() {
      this.$v.$touch();
      if (this.$v.$invalid) {
          return;
      }
      let formData = {
        Id: this.brand.Id,
        Name: this.brand.Name,
        IsForTool : this.brand.IsForTool,
        IsForCapacityEquipment : this.brand.IsForCapacityEquipment,
        IsForSparePart : this.brand.IsForSparePart,
        IsForDevice : this.brand.IsForDevice,
        IsActive: true
      };
      blockui.blockModal(this);
      try{
        const response  = await this.apiClient.brand.brandSave(formData);
        if (response.data.IsSuccess) {
          toastr.success(this.translate('save_successfully'));
          this.saveSucceeded();
          this.close();
        } else {
          const errorMessage = response.data.Message ? response.data.Message : "Error";
          toastr.error(errorMessage);
        }
      }
      catch(e){
        console.log("err",e)
        toastr.error(e);
      }
      finally{
        blockui.unBlockModal();
      }
    }
}
